import SButton from "components/Common/Button"
import React, { useEffect, useState, useRef } from "react"

import { useHistory, useLocation } from "react-router-dom"
import {
  getCorporateOrdersEditApi,
  getInspectionHistoryApi,
  shipOrderApi,
  updateBulkDelivery,
  updateCorporateOrderApi,
  getPrintRwtOrder,
} from "helpers/corporate_orders"

import OrderDetailTab from "./OrderDetailTab"
import InspectionTab from "./InspectionTab"
import {
  defaultEditPayload,
  defaultOrderDetails,
  tabStates,
} from "../default-values"
import { toast } from "react-toastify"
import { Col, Container, Row } from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import BackButton from "components/Common/BackButton"
import Canvas from "./Canvas"

export default function Edit() {
  const [data, setData] = useState(null)
  const [orderDetailData, setOrderDetailData] = useState(null)
  const [inspectHistory, setInspectHistory] = useState(null)
  const [payload, setPayload] = useState(defaultEditPayload)
  const [canvas, setCanvas] = useState([])
  const [trigger, setTrigger] = useState(0)

  const [tabState, setTabState] = useState(tabStates[0])

  const [isError, setIsError] = useState(false)

  const getCanvasRef = useRef()

  const {
    state: { id },
  } = useLocation()

  const history = useHistory()

  const loadData = async id => {
    try {
      const { data } = await getCorporateOrdersEditApi({ id })
      const _payload = { ...payload }

      data.sizes.forEach(item => {
        const _payloadIdx = _payload.sizes.findIndex(m => m.size === item.size)
        _payload["sizes"][_payloadIdx]["orderQty"] = item.orderQty
        _payload["sizes"][_payloadIdx]["unitPrice"] = item.unitPrice
      })

      const _orderDetailsData = {
        ...defaultOrderDetails[data.type],
      }

      data.sizes.forEach(size => {
        const orderDetailIdx = _orderDetailsData.sizes.findIndex(
          item => item.size === size.size
        )

        _orderDetailsData.sizes[orderDetailIdx].defect = size.defect || 0
        _orderDetailsData.sizes[orderDetailIdx].orderQty = size.orderQty
        _orderDetailsData.sizes[orderDetailIdx].maxReducedProduction =
          size.maxReducedProduction

        _orderDetailsData.sizes[orderDetailIdx].unitPrice = Number(
          size.unitPrice || 0
        )
        if (data.type === "ファクトリーメイド") {
          _orderDetailsData.incompleteDeliveries[orderDetailIdx] =
            size.orderQty - (size.numberOfDeliveries || 0)

          _orderDetailsData.sizes[orderDetailIdx].unfinished =
            size.orderQty - (size.numberOfDeliveries || 0)

          _orderDetailsData.numberOfDeliveries[orderDetailIdx] =
            size.numberOfDeliveries
        } else {
          _orderDetailsData.numberOfRemaining[orderDetailIdx] =
            size.orderQty - (size.numberOfDeliveries || 0) - (size.defect || 0)

          _orderDetailsData.completedInspection[orderDetailIdx] =
            size.numberOfDeliveries
        }
      })

      setOrderDetailData(_orderDetailsData)
      setPayload(_payload)
      setData(data)
    } catch (error) {
      console.log(error)
    }
  }

  const loadInspectHistory = async (id = id) => {
    try {
      const { data } = await getInspectionHistoryApi({ id })
      setInspectHistory(data)
    } catch (error) {
      console.log(error)
    }
  }

  const onSizeChange = e => {
    const _payload = { ...payload }
    const {
      value,
      name,
      dataset: { size },
    } = e.target
    const idx = _payload.sizes.findIndex(item => item.size === size)
    const org = data.sizes.find(item => item.size === size)
    if (!org) return
    _payload.sizes[idx][name] = +value
    setPayload(_payload)
  }

  /**
   * todo: refactor these identical functions
   */
  const onCompletedInspectChange = e => {
    const {
      value,
      dataset: { size },
    } = e.target

    const _orderDetailData = { ...orderDetailData }

    const _sizes = [...payload.sizes]
    const sizeIdx = payload.sizes.findIndex(item => item.size === size)
    _sizes[sizeIdx].completedInspection = +value

    // _orderDetailData.incompleteDeliveries[sizeIdx] =
    //   _sizes[sizeIdx].orderQty - +value
    // _orderDetailData.numberOfDeliveries[sizeIdx] = +value

    const _payload = { ...payload, sizes: _sizes }
    setPayload(_payload)
  }

  const onReducedProdChange = e => {
    const {
      value,
      dataset: { size },
    } = e.target

    const _orderDetailData = { ...orderDetailData }

    const _sizes = [...payload.sizes]
    const sizeIdx = payload.sizes.findIndex(item => item.size === size)

    _sizes[sizeIdx].reducedProduction = +value

    if (data.type === "ファクトリーメイド") {
      _orderDetailData.completedInspection[sizeIdx] =
        _sizes[sizeIdx].orderQty - +value

      // _orderDetailData.numberOfDeliveries[sizeIdx] = +value

      // _orderDetailData.incompleteDeliveries[sizeIdx] =
      //   _sizes[sizeIdx].orderQty - +value
    } else {
      // ini dikomen elfin
      _orderDetailData.numberOfRemaining[sizeIdx] =
        _sizes[sizeIdx].orderQty - +value
      // _orderDetailData.completedInspection[sizeIdx] = +value
    }

    const _payload = { ...payload, sizes: _sizes }

    setOrderDetailData(_orderDetailData)
    setPayload(_payload)
  }

  const onBulkClick = async () => {
    try {
      const res = await updateBulkDelivery({ id })
      console.log(res)
      window.location.href = "/corporate-orders"
    } catch (error) {
      console.log(error)
    }
  }

  const [isSubmitting, setIsSubmitting] = useState(false)
  const onSubmitPress = redirect => {
    setIsSubmitting(true)

    setTabState(tabStates[1])
    setTimeout(() => {
      onSubmit(redirect)
    }, 1000)
  }

  const onSubmit = async redirect => {
    let getCanvas = await getCanvasRef.current.saveCanvas()
    try {
      let isInvalid = false
      let _payload = {
        ...payload,
        sizes: payload.sizes.filter(item => item.orderQty),
      }
      setTimeout(async () => {
        if (redirect) {
          _payload = {
            ..._payload,
            image: getCanvas?.details[0].image ?? "",
            json: getCanvas?.details[0].json ?? {},
          }
        }

        _payload.sizes.forEach(size => {
          const org = data.sizes.find(item => item.size === size.size)

          if (size.size > org.size) {
            isInvalid = true
          }
        })

        if (isInvalid) {
          setIsError(true)
          return
        }

        await updateCorporateOrderApi({ id, params: _payload })
        setIsSubmitting(false)
        // console.log(res)
        if (redirect) {
          window.location.href = "/corporate-orders"
        } else {
          window.location.reload()
        }
      }, (getCanvas?.details.length || 2) * 1000)
    } catch (error) {
      setIsSubmitting(false)
      toast.error(error?.response?.data?.message)
      console.log(error)
    }
  }

  const onShipping = async () => {
    try {
      const res = await shipOrderApi({ id })
      if (!res.error) window.location.href = "/corporate-orders"
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    if (id) {
      loadData(id)
      loadInspectHistory(id)
    }
  }, [id])

  const onPrint = async () => {
    try {
      const { data } = await getPrintRwtOrder(id)
      const link = document.createElement("a")
      link.href = URL.createObjectURL(
        new Blob([data], { type: "application/pdf" })
      )
      link.setAttribute(
        "download",
        "order_rtw_report" + new Date().getTime() + ".pdf"
      )
      document.body.appendChild(link)
      link.click()
    } catch (error) {
      console.log(error)
    }
  }

  const config = {
    data,
    onSizeChange,
    payload,
    onSubmit,
    isError,
    onCompletedInspectChange,
    onReducedProdChange,
    onBulkClick,
    onShipping,
    orderDetailData,
    loadData,
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title={tabState.title} breadcrumbList={[]} />
        <Row className="my-2">
          <Col sm={6}>
            <SButton
              style={{ width: 150, borderRadius: 0 }}
              className={`${
                tabState.tab === "受注詳細" ? "button-active" : "button"
              }`}
              onClick={() => setTabState(tabStates[0])}
            >
              受注詳細
            </SButton>
            <SButton
              style={{ width: 150, borderRadius: 0 }}
              className={`${
                tabState.tab === "検品" ? "button-active" : "button"
              }`}
              onClick={() => setTabState(tabStates[2])}
            >
              検品
            </SButton>
            <SButton
              style={{ width: 150, borderRadius: 0 }}
              className={`${
                tabState.tab === "手書きノート" ? "button-active" : "button"
              }`}
              onClick={() => setTabState(tabStates[1])}
            >
              手書きノート
            </SButton>
          </Col>
          <Col sm={6} className="d-flex justify-content-end">
            <div className="d-flex gap-4">
              {/* 印刷: printing */}
              <SButton className="button" onClick={() => onPrint()}>
                印刷
              </SButton>
              {data?.status !== "出荷完了" && (
                <SButton className="button" onClick={onShipping}>
                  出荷
                </SButton>
              )}

              {data?.type !== "アトリエメイド" && (
                <SButton className="button" onClick={onBulkClick}>
                  一括納品
                </SButton>
              )}

              {/* keep/save button  */}
              <SButton
                loading={isSubmitting}
                className="button"
                onClick={() => onSubmitPress(true)}
              >
                保存
              </SButton>
              {/* cancel button below, we'll see what to do with it */}
              <BackButton className="button" />

              {/* shipping button/submit */}
            </div>
          </Col>
        </Row>

        {data &&
          (tabState.tab === "受注詳細" ? (
            orderDetailData && (
              <OrderDetailTab config={config} type={data.type} />
            )
          ) : tabState.tab === "検品" ? (
            inspectHistory && <InspectionTab data={inspectHistory} />
          ) : (
            <Canvas
              setCanvas={v => setCanvas(v)}
              data={data}
              trigger={trigger}
              ref={getCanvasRef}
            />
          ))}
      </Container>
    </div>
  )
}
